<template>
  <div id="audiolist">
    <ul class="ulaudio">
      <li v-for="(item, index) in $store.state.audio.MList" :key="index" :class="{'itemactive':index == $store.state.audio.audioIndex }" >
          <div class="num">
              <span class="numindex"> {{index+1}}</span>
          </div>
          <div class="listcon">
              <div class="leftbox">
                <p class="title ellipse">{{item.collectionName}}</p>
                <p class="time">
                     <span>10-16</span>
                     <img src="../../assets/images/guide/timer.png" alt="">
                     <span v-show="index == $store.state.audio.audioIndex ">{{time}}</span>
                </p>
              </div>
              <div class="rightbox">
                <img class="playicon" v-if="showPlayStop||index != $store.state.audio.audioIndex" src="../../assets/images/guide/zhan.png" @click="isPlay(index)">
                <img class="stopicon" v-if="!showPlayStop&&index == $store.state.audio.audioIndex" src="../../../static/images/audio/detailstop.svg" @click="isStop">
              </div>
          </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'app',
    data(){
        return{
         apiUrl: 'http://www.egtch.com/t_works/Vuedata/data.php',
          id: 0,
          time:0,
          showPlayStop:true
        }
    },
    props:{
      videoList:Array
    },
    mounted(){
        let _this = this;
      setInterval(function (){
        var audio = document.getElementById("audio");
        _this.time = audio && audio.currentTime && _this.formatSeconds(audio.currentTime);
      },1000);
      //this.getMusic(this.$store.state.audio.mutations.audioIndex);
       // this.getMusic(this.id);
      this.init(this.id);
    },
    computed: mapState({
      count:state=>state.audio.playing
    }),
  /*computed: {
    ...mapState('audio',[
      'audioIndex',
      'music',
      'MList',
      'audioshow'
    ])
  },*/
    watch:{
      count:function (newval,oldval) {
     if(this.$store.state.audio.audioshow){
       if(newval){
         this.showPlayStop=false;
       }else{
         this.showPlayStop=true;
       }
     }else{
       this.showPlayStop=true;
     }

      },
        'id':'getMusic',
    },
  activated() {
    this.init(this.id);
  },
    methods:{
        init(p){
          var _this=this;
            _this.data=this.videoList;
            _this.$store.state.audio.MList=this.videoList;
            _this.$store.state.audio.music=this.videoList[0];
            this.$store.dispatch('hideAudio');
           this.id = this.$store.state.audio.audioIndex
        },
      getMusic(p){
        this.$store.state.music="";
        document.getElementById("audio").currentTime="0";
        if(p < this.$store.state.audio.MList.length) {
          // this.music = response.music[p]
          this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
        }
        if(p > this.$store.state.audio.MList.length){
          this.id = 0
          this.$store.state.audio.audioIndex = 0
          this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
        }
        if(p < 0){
          this.id = this.$store.state.audio.MList.length
          this.$store.state.audio.audioIndex = this.$store.state.audio.MList.length
          this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
        }
        //})

      },
        /*查看当前audio是否正在播放，如果停止，那么播放下一曲*/
        isPlay(index){
            this.id = index;
           this.showPlayStop=false;
            this.$store.state.audio.playing=true;
            this.$store.state.audio.audioIndex = index;
            this.$store.dispatch('showAudio');
            document.getElementById("audio").play();
            return false
        },
        isStop(){
            document.getElementById("audio").pause();
            this.showPlayStop=true;
          this.$store.state.audio.playing=false;
            return false
        },
      formatSeconds(value) {
        var hh = parseInt(value/3600);
        if(hh<10) hh = "0" + hh;
        var mm = parseInt((value-hh*3600)/60);
        if(mm<10) mm = "0" + mm;
        var ss = parseInt((value-hh*3600)%60);
        if(ss<10) ss = "0" + ss;
        // var length = hh + ":" + mm + ":" + ss;
        var length =  mm + ":" + ss;
        if(value>0){
          return length;
        }else{
          return "NaN";
        }
      }
    }
}
</script>

<style scoped>
  #audiolist{
    clear: both;
  }
.ulaudio{
  margin-top: 1rem;

}
.ulaudio li{
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  width:17.25rem;
  height:3.1rem;
  background:rgba(241,241,242,1);
  border-radius:0.4rem;
}
.num{
  width: 0.49rem;
  height: 2rem;
  line-height: 2rem;
  font-size:0.7rem;
  font-family:PingFang-SC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  margin-right: 1rem;
  margin-top: .5rem;
  margin-left: 0.5rem;
}
.num img{
  width: 0.24rem;
  height: 0.32rem;
  vertical-align: middle;
}
.listcon{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}
.listcon .leftbox{
  width: 9rem;
}
.listcon .leftbox .title{
  height:1rem;
  font-size:0.7rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:1rem;
  margin-top: 0.4rem;
}
.listcon .leftbox .time{
    margin-top: 0.2rem;
    height: 1rem;
    line-height: 1rem;
}
.listcon .leftbox .time img{
    height: 0.5rem;
    width: 0.5rem;
    margin-right: 0.12rem;
}
  .listcon .leftbox .time span{
    font-size:0.6rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(185,185,185,1);
    line-height:0.85rem;
  }
  .listcon .leftbox .time span:nth-child(3).active{

  }
  .listcon .rightbox{
  margin-top: 0.5rem;
    margin-right: 0.5rem;
}
.listcon .rightbox img{
  width:1rem;
  height:1rem;
  margin-top: .5rem;
}
.speakericon{display: none;}
.stopicon{display: none;}

.itemactive .speakericon{display: inline;}

.itemactive .stopicon{display: inline;}

</style>



// WEBPACK FOOTER //
// src/components/audio/audiolist.vue